import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 自动引入modules目录下的文件
const modules: any = {};
require.context('./modules', false, /.ts$/).keys().forEach((i: any) => {
  modules[i.substring(2, i.length - 3)] = require(`./modules/${i.substring(2, i.length)}`).default;
});
// console.log(modules)
export default new Vuex.Store({
  modules,
});
